import React from 'react';
import styled from 'styled-components';
import { ContentProps } from './models';
import classNames from 'classnames';
import * as styles from './styles';

const Content = React.memo(
  styled(({ className: _className, children, title }: ContentProps) => {
    const className = classNames(_className, 'content');
    return (
      <nav className={className}>
        {title && <h2 className="title">{title}</h2>}
        {children}
      </nav>
    );
  })`
    ${styles.Content}
  `
);

export default Content;
